import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

  constructor(       @Inject(MAT_DIALOG_DATA) public data: any,
                     private dialogRef: MatDialogRef<ConfirmDialogComponent>, private router: Router) { }

  ngOnInit(): void {
  }

  continueToBuy(){
    this.router.navigateByUrl('web/checkout-process');
    this.dialogRef.close();
  }

  close(){
    this.dialogRef.close();

  }

}
